{
  "list": {
    "title": "Liste des connexions",
    "subtitle": "Liste des connexions Chronopost",
    "newLink": "Ajouter une connexion"
  },
  "create": {
    "title": "Créer une connexion d'un transporteur expressiste",
    "subtitle": "Formulaire de création d'une connexion d'un transporteur expressiste"
  },
  "update": {
    "title": "Éditer une connexion d'un transporteur expressiste",
    "subtitle": "Formulaire d'édition d'une connexion d'un transporteur expressiste"
  },
  "detail": {
    "title": "Détail d'une connexion",
    "subtitle": "Transporteur - {transporterName} / Connexion - {connexionName}",
    "transporterInformation": "Informations Transporteur",
    "connexionInformation": "Informations Connexion",
    "linkInformation": "Informations Liaison"
  },
  "table": {
    "name": "Connexion",
    "type": "Type de connexion",
    "service": "Service",
    "linkCount": "Nb liaisons"
  },
  "filters": {
    "operatingCenter": "Centre d'exploitation"
  },
  "fields": {
    "transporterName": "Nom",
    "transporterType": "Type du transporteur",
    "weight": "Poids max (kg)",
    "power": "Puissance max (wh)",
    "height": "Hauteur max (mm)",
    "width": "Largeur max (mm)",
    "name": "Connexion",
    "connexionName": "Nom de la connexion",
    "type": "Type de connexion",
    "identifier": "Identifiant",
    "password": "Mot de passe",
    "service": "Service(s)",
    "network": "Réseau grand compte",
    "operatingCenter": "Centre d'exploitation",
    "priority": "Utilisation de cette liaison en priorité",
    "repairCenterScopeMode": "Mode centres de réparation",
    "repairCenterScopeModeAuto": "Automatique",
    "repairCenterScopeModeManual": "Manuel",
    "repairCenterManualScopeLabel": "Configurer manuellement les centres de réparation",
    "repairCenterAllowedLabel": "Centres de réparation autorisés",
    "linkPriorityLabel": "Utiliser cette liaison en priorité"
  },
  "form": {
    "connexionTitle": "Connexion",
    "linkTitle": "Liaison"
  },
  "placeholders": {
    "connexionService": "Sélectionner un service de connexion",
    "connexionName": "Ex : Nom de la connexion",
    "connexionType": "Sélectionner un type de connexion",
    "connexionIdentifier": "Ex : ID.TRANSPORT",
    "connexionPassword": "Saisir le mot de passe de connexion",
    "keyAccountNetwork": "Sélectionnez le réseau grand compte",
    "operatingCenter": "Sélectionnez le centre d'exploitation",
    "repairCenterAllowed": "Sélectionner un ou plusieurs centres de réparation autorisés"
  },
  "actions": {
    "create": "Valider la création de la connexion",
    "update": "Valider l'édition de la connexion"
  },
  "search": "Rechercher",
  "connexionTypes": {
    "OPERATING_CENTER": "Centre d'exploitation"
  },
  "deleteModal": {
    "title": "Suppression de la connexion d'un expressiste",
    "message": "Voulez-vous vraiment supprimer la connexion {connexion}?",
    "warning": "Cette action est irréversible."
  },
  "messages": {
    "createSuccess": "La connexion a l'expressiste a été crée avec succés",
    "updateSuccess": "La connexion a l'expressiste a été modifié avec succés",
    "deleteSuccess": "La connexion a l'expressiste a été supprimé avec succès"
  }
}
